import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useNavigate } from "react-router-dom";
import { ReactSession } from "react-client-session";
import axios from "axios";
ReactSession.setStoreType("localStorage");


const Address = () => {
    const userId = ReactSession.get("welbeinguserId");
    const [error, setError] = useState("");
    const [address, setAddress] = useState({});
    const navigate = useNavigate();
    const handleAddChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setAddress((values) => ({ ...values, [name]: value }));
  };

  const handleAddSubmit = async (event) => {
    event.preventDefault();
    // console.log(address);
    const formData = {
       cust_id: userId, // Include the userId in the form data
       name: address.name, 
       phonenumber: address.phonenumber,
       email:address.email,
       address:address.address,
       location:address.city,
       pincode:address.pin,// Spread other address fields if they are separate
    };
    // console.log(formData);
    try {
      const response = await axios.post(
        `https://api.welbeing.in/address/add-address/`,
        formData
      );
      navigate('/checkout');
      // alert(`Address Added successfully`);
    } catch (error) {
      console.error("There was a problem with login:", error);
      setError("Address Not Inserted");
    }
  };
    return (
        <>
            <Header />

            <main className="main">
                <div className="breadcrumb-wrap" id="breadcrumb-margin">
                     <div className="banner" style={{minHeight:'10px'}}>
                        <img className="bg-img bg-top" src="../assets/images/inner-page/banner-p.jpg" alt="banner" />

                        <div className="container-lg">
                            <div className="breadcrumb-box">
                                <div className="heading-box">
                                    <h1>Address</h1>
                                </div>
                                <ol className="breadcrumb">
                                    <li><a href="/">Home</a></li>
                                    <li>
                                        <a href="#"><i data-feather="chevron-right"></i></a>
                                    </li>
                                    <li className="current"><a href="">Address</a></li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Breadcrumb End */}

                {/* Blog Detail Section Start */}
                <section>
                    <div className="container-lg">
                        <div className="row gy-5 g-lg-3 g-xxl-4">
                            <div className="col-lg-10 order-1 order-lg-2 ratio_36">
                                <div className="blog-wrap">
                                    {/* Reply From Section Start */}
                                    <div className="replay-form round-wrap-content top-space" id="replaySection">
                                        <div className="title-box4">
                                            <h4 className="heading">Add Address<span className="bg-theme-blue"></span></h4>
                                        </div>

                                        <form  onSubmit={handleAddSubmit} className="custom-form form-pill">
                                            <div className="row g-3 g-sm-4">
                                                <div className="col-sm-4">
                                                    <div className="input-box">
                                                        <label htmlFor="name">Full Name</label>
                                                        <input type="hidden" name="id"  />
                                                        <input type="text" className="form-control" name="name"  placeholder="First name*" value={address.name} onChange={handleAddChange} required/>
                                                    </div>
                                                </div>
                                                <div className="col-sm-4">
                                                    <div className="input-box">
                                                        <label htmlFor="email">Email Address</label>
                                                        <input type="text" name="email" className="form-control" required  placeholder="Email*" value={address.email} onChange={handleAddChange} />
                                                    </div>
                                                </div>
                                                <div className="col-sm-4">
                                                    <div className="input-box">
                                                        <label htmlFor="phone">Phone number</label>
                                                        <input type="text" name="phonenumber" className="form-control" placeholder="Whatsapp number*" value={address.number} onChange={handleAddChange}/>
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className="input-box">
                                                        <label htmlFor="address">Address</label>
                                                        <input type="text" name="address" className="form-control" placeholder="Enter Address*" value={address.address} onChange={handleAddChange}/>
                                                    </div>
                                                </div>
                                                <div className="col-sm-6">
                                                    <div className="input-box">
                                                        <label htmlFor="city">City</label>
                                                        <input type="text" name="city" className="form-control" placeholder="Enter Town/city*"  value={address.city} onChange={handleAddChange}/>
                                                    </div>
                                                </div>
                                                <div className="col-sm-6">
                                                    <div className="input-box">
                                                        <label htmlFor="zip">Zip code</label>
                                                        <input type="text" name="pin" className="form-control" placeholder="Enter Pincode/ Zip *" value={address.pin} onChange={handleAddChange}/>
                                                    </div>
                                                </div>
                                                <div className="col-12 text-end">
                                                    <button name="address" className="post-button btn btn-solid btn-sm mb-line">
                                                        Submit <i className="arrow"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* Blog Detail Section End */}
            </main>

            <Footer />
        </>
    );
};

export default Address;